import {
  index,
  integer,
  jsonb,
  pgEnum,
  pgTable,
  text,
} from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { addresses } from './address'
import { customers } from './customer'
import { subscriptions } from './subscription'

// Property type enum
export const propertyTypeEnum = pgEnum('property_type', [
  'detached_house',
  'semi_detached',
  'row_house',
  'apartment_building',
  'commercial_property',
])

export const properties = pgTable(
  'properties',
  {
    ...getBaseFields(),
    customerId: getIdReference(() => customers.id),
    propertyType: propertyTypeEnum().notNull(),
    constructionYear: integer(),
    notes: text(),
    data: jsonb(),
    addressId: getIdReference(() => addresses.id).notNull(),
  },
  (table) => [
    ...getBaseIndexes('properties', table),
    index('properties_customer_id_idx').on(table.customerId),
    index('properties_address_id_idx').on(table.addressId),
  ],
)

export const propertiesRelations = relations(properties, ({ one, many }) => ({
  customer: one(customers, {
    fields: [properties.customerId],
    references: [customers.id],
  }),
  address: one(addresses, {
    fields: [properties.addressId],
    references: [addresses.id],
  }),
  subscriptions: many(subscriptions),
}))
